import { isScriptFullyLoaded, markScriptFullyLoaded } from '@/utils/dom';
import {idToGid} from "@/utils/graphql";
import {storefrontApiKey} from "@/services/products";

export const isFinalSale = (price, compareAtPrice) =>
  compareAtPrice && 1 - price / compareAtPrice >= 0.39;

export const formatPrice = (n) => {
  n = +n;
  return n % 1 === 0 ? n.toString() : n.toFixed(2);
};

export const retrieveSku = (jointSku) => {
  const skuSplit = jointSku.split('-');
  return skuSplit[1];
};

export const isUnreturnable = (product) => {
  const productType = product.type?.toUpperCase();
  return productType === 'MASK' || productType === 'SWIMWEAR';
};

export const getProductVariantData = async (variantFromSelection) => {
  if (window.Shopify.currency.active == 'USD') {
    return {
      sku: variantFromSelection.sku,
      id: variantFromSelection.id,
      price: variantFromSelection.price / 100,
      compare_at_price: variantFromSelection.compare_at_price / 100,
    };
  }

  const query = `
    query {
      node(id: "gid://shopify/ProductVariant/${variantFromSelection.id}") {
        ... on ProductVariant {
          priceV2 {
            amount
            currencyCode
          }
          compareAtPrice {
            amount
            currencyCode
          }
        }
      }
    }
  `;

  try {
    const response = await fetch(
      'https://bugatchi-group-inc.myshopify.com/api/2023-07/graphql.json',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token':
            'ec8327db27d6cc7c87157bb7b77a92cb',
        },
        body: JSON.stringify({ query }),
      }
    );
    const { data } = await response.json();
    return {
      sku: variantFromSelection.sku,
      id: variantFromSelection.id,
      price: data.node?.priceV2?.amount,
      compare_at_price: data.node?.compareAtPrice?.amount,
    };
  } catch (error) {
    console.error(error);
  }
};

export const loadJavaScript = (url) => {
  const script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};

export const getPDPContent = async (handle) => {
  try {
    const targetUrl = `/products/${handle}?section_id=pdp`;
    const response = await fetch(targetUrl);
    const data = await response.text();

    const parser = new DOMParser();
    return parser.parseFromString(data, 'text/html');
  } catch (e) {
    console.error(e);
  }
};

export const getVariantQuantity = async (variantId) => {
  const query = `
    query getVariantQuantity($variantId: ID!) {
      node(id: $variantId) {
        ... on ProductVariant {
          id
          quantityAvailable
        }
      }
    }
  `;

  try {
    const resp = await fetch(
      `${window.Shopify.routes.root}api/2024-10/graphql.json`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Shopify-Storefront-Access-Token': storefrontApiKey,
        },
        body: JSON.stringify({
          query,
          variables: {variantId: idToGid('ProductVariant', variantId)},
        }),
      }
    );
    return (await resp.json())?.data?.node;
  } catch (error) {
    console.error(error);
  }
};
